import { SDK } from '../index';
import {
    LikeProfileInput,
    LikeProfileMutationVariables,
    ResultSuccess,
} from '../generated/graphql';

export const likeProfile = async (
    data: LikeProfileInput,
    sdk: SDK,
): Promise<ResultSuccess> => {
    const mutation = require('../graphql/mutations/likeProfile.mutation.gql');
    return sdk.mutate<
        {
            likeProfile: ResultSuccess;
        },
        LikeProfileMutationVariables
    >(
        {
            mutation: mutation,
            variables: { l_Data: data },
        },
        'likeProfile',
        false,
    );
};
